/*globals $, document, ajaxUrl */

/**
 * Functionality to toggle nutrition information depending on chosen option
 */

$(document).ready(function () {
    "use strict";

    $("[data-nutrition-option]").on("change", function (e) {
        NUTRITION.getNutritionInfo($(e.target).val(), $(e.target).data("nutrition-option"));
    });
});

var NUTRITION = {

    getNutritionInfo: function (id, type) {
        "use strict";

        var data = {
                "action": "update_nutrition_info",
                "parent": $("[data-nutrition-option]").find("option")[0].value,
                "item": id,
                "type": type
            },
            generateInfo = $.ajax({
                type: "post",
                url: ajaxUrl,
                dataType: "html",
                data: data
            });

        generateInfo.done(function (result) {
            var template = "";

            $.each($(result), function () {
                template = $(this).attr("class");

                $("[data-template=\"" + template + "\"]").html($(this).html());
            });
        });
    }
}

var PrintFormatter = {
  sections: [],
  formatNutritionalInfo: function(){

      // in general apply a page-break at the end of each table in each section
      var nutrition = $(".nutrition");

      nutrition.each(function(i, o){
        var classes = o.classList,
           section = classes[classes.length - 1];

        if(!PrintFormatter.sections.includes(section)){
          PrintFormatter.sections.push(section);
        }
      });

      $.each(PrintFormatter.sections, function(i, o){
        var allSections = $("ul#nutriAller.nutrition." + o),
            lastSection = allSections.last(),
            exceptionRows = [
              // "Rancheros Omelette (1 serving) with Side Choice Breakfast Potatoes",
              // "Meat Lovers Omelette (1 serving) with Side Choice Breakfast Potatoes",
              // "Ham and Cheese Omelette (1 serving) with Strawberry Jam for Toast",
              // "Red, White and Blueberry Pancakes (1 serving)",
              "Cinnamon Bun Pancakes (1 serving)",
              // "Crispy Honey Mustard Chicken Sandwich on a Pretzel Roll (1 serving)",
              // "Friendly's Big Beef® 1/2 Pound + Bacon Cheeseburger†",
              // rom"Philly Steak and Cheese Omelette (1 serving) with White Toast"
            ];

        // if we add a new section to "Kids" or add a new product to the "Kids Drinks" section we'll have to
        // update with the new last item's name
        if(lastSection.find("li").first().html() !== "Soda or Lemonade"){
            lastSection.css("page-break-after", "always");
        }

        // add in some hard coded fixes to put specific items on a new page.
        allSections.each(function(i, o){

          var prodName = $(this).find("li").first().text();

          if(exceptionRows.includes(prodName)){
            $(this).css("page-break-before", "always");
          }

        });

      });
  },

  formatAllergenInfo: function(){
      /* don't put page breaks after the column headers of sections that are directly below h2's, */
      var exceptionSections = ["burgers", "specialty-treats", "classics", "kids-breakfast"],
          exceptionRows = [
            // "Friendly's Big Beef® 1/2 Pound + Bacon Cheeseburger†",
            // "Rancheros Omelette (1 serving) with Butter for Toast"
            "Philly Steak and Cheese Omelette (1 serving) with Side Choice Breakfast Potatoes"
          ];

      $("ul#colTitles").filter(".allergens").filter(":visible").each(function(){
          var curSectionTitle = this.classList[this.classList.length - 1];

          if(!exceptionSections.includes(curSectionTitle)){
            $(this).css("page-break-before", "always");
          }
        });

      /* manually add page breaks after the "breakfast" and "kids" headings... */
      $(".nutritionallergensPage h2").each(function(){

        if($(this).html() == "Breakfast" || $(this).html() == "Kids"){
            $(this).css("page-break-before", "always");
        }

      });

      // add in some hard coded fixes to put specific items on a new page.
      $.each(PrintFormatter.sections, function(i, o){

        var curRow = $("ul#nutriAller.allergens." + o);

        curRow.each(function(){
          var prodName = $(this).find("li").first().text();

          if(exceptionRows.includes(prodName)){
            $(this).css("page-break-before", "always");
          }
        });
      });
  }
}

PrintFormatter.formatNutritionalInfo();

$(".allergenic").click(function(){

  /* don't put page breaks after the column headers of sections that are directly below h2's,
  Will have to be re-visited when new categories are added, but since new categories have to added in code anyway
  I think this is an ok fix */
  var exceptionSections = ["burgers", "specialty-treats", "breakfast-classics", "kids-breakfast"];

  $.each(PrintFormatter.sections, function(i, o){

    var seg = $(".segmentedControlContainer." + o);

    seg.find("a:last-child").trigger("click");
  });

  PrintFormatter.formatAllergenInfo();

  window.print();

  return false;
});

$(".nutritional").click(function(){

  $.each(PrintFormatter.sections, function(i, o){

    var seg = $(".segmentedControlContainer." + o);

    seg.find("a:first-child").trigger("click");
  });

  window.print();

  return false;
});
